import React, {useEffect, useState, useCallback } from 'react';
import { MLRSSUtil } from 'ml-portals-util-js';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';

import metadata from './MLMoratoriumsComponent.metadata.json5';
import styles from './MLMoratoriumsComponent.module.scss';


const MLMoratoriumsComponent = (props) => {
    const { currentUser } = props;
    const ALL_STATE_MARKER = 'ALL';
    const HIGH_PRIORITY_MARKER = 2;
    const feedLink = `https://foremostproducernews.com/feed`;

    const [isRSSDataLoading, setRSSDataLoading] = useState(true);
    const [producerNews, setProducerNews] = useState([]);
    const [moratoriums, setMoratoriums] = useState([]);

    useEffect(() => {
        const timeoutHandle = setTimeout(() => {
            MLRSSUtil.retrieveRSSDataFromFeed(feedLink).then((res) => {
                try {
                    const producerNewsRssItems = MLRSSUtil.handleOnLoad(res);
                    setProducerNews(producerNewsRssItems);
                    setRSSDataLoading(false);
                } catch(error) {
                    console.error(error);
                    setRSSDataLoading(false);
                }                   
            }, (error) => {
                console.error(error);
                setRSSDataLoading(false);
            });
        }, 10);

        return () => clearTimeout(timeoutHandle); 
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, []);

    const filterForItemsWithSingleUserChannel = (item, user, doesItemContainState) => user.state === ALL_STATE_MARKER ? (item.channel === user.userType) : item.channel === (user.userType) && doesItemContainState;

    const filterForItemsWithMultipleUserChannels = (item, user, doesItemContainState) => user.state === ALL_STATE_MARKER ? item.channel.indexOf(user.userType) !== -1 : item.channel.indexOf(user.userType) !== -1 && doesItemContainState;

    const filterHighPriorityItemsForMoratoriums = (highPriorityItems, user) => {
        return highPriorityItems.filter((item) => {
            const isItemAvailableForUserState = item.state.indexOf(user.state) !== -1;
            return Array.isArray(item.channel) ? filterForItemsWithMultipleUserChannels(item, user, isItemAvailableForUserState)
                : filterForItemsWithSingleUserChannel(item, user, isItemAvailableForUserState);
        });
    };
    
    const filterRssResponseForMoratoriumDisplay = useCallback((res, userObject) => {
        const highPriorityItems = res.filter((item) => parseInt(item.priority) === HIGH_PRIORITY_MARKER && item.category && item.category.indexOf('Alerts') !== -1);

        if (highPriorityItems.length > 0) {
            return filterHighPriorityItemsForMoratoriums(highPriorityItems, userObject);
        }
        return [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    useEffect(() => {
        if (!_.isEmpty(currentUser) && !isRSSDataLoading) {
            const userObject = {userType: currentUser.userTypeName_ML, state: 'ALL'};
            setMoratoriums(filterRssResponseForMoratoriumDisplay(producerNews, userObject) || []);
        }       
    }, [currentUser, isRSSDataLoading, filterRssResponseForMoratoriumDisplay, producerNews]);

    const generateOverrides = () => {
        const overrides = moratoriums.map((item, index) => {
            return {
                [`seperator${index}`]: {
                    visible: index > 0
                },
                [`linkItem${index}`]: {
                    visible: !_.isUndefined(item.link)
                },
                [`noLinkItem${index}`]: {
                    visible: !item.link
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const overrideProps = {
        moratoriumsContainer: {
            visible: moratoriums.length > 0
        },
        moratoriumsIcon: {
            src: 'farmers/foremost-alert.png',
            alt: 'Warning alert',
        },
        moratoriumsIterable: {
            data: moratoriums
        },
        emptyContainer: {
            visible: moratoriums.length > 0,
            content: (
                <>
                     &nbsp;
                </>
            )
        },
        moratoriumsIconContainer: {
            visible: moratoriums.length > 0,
            role: 'navigation',
            'aria-label': 'Moratoriums and Alerts'
        },
        moratoriumsContentContainer: {
            visible: moratoriums.length > 0            ,
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={moratoriums}
            classNameMap={resolvers.resolveClassNameMap}
        />        
    );
};

MLMoratoriumsComponent.propTypes = {
    currentUser: PropTypes.object
}

MLMoratoriumsComponent.defaultProps = {
    currentUser: {}
}

export default MLMoratoriumsComponent;
